import { render, staticRenderFns } from "./CommonModalLeadJourney.vue?vue&type=template&id=0ddad269&scoped=true&"
import script from "./CommonModalLeadJourney.vue?vue&type=script&lang=js&"
export * from "./CommonModalLeadJourney.vue?vue&type=script&lang=js&"
import style0 from "./CommonModalLeadJourney.vue?vue&type=style&index=0&id=0ddad269&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddad269",
  null
  
)

export default component.exports